import React from "react";
// @ts-ignore
import Clock from 'react-live-clock';

import '../Menu.css';

interface Props {
    active: string;
    startOverAction: () => void;
}

const ReceptionMenu: React.FC<Props> = ({ active, startOverAction }) => {
    return (
        <div className="menu reception-menu">
            <Clock format={'HH:mm'} ticking={true} timezone={'Europe/Copenhagen'} interval={30000} />
            <div className="menu-point-container">
                <div className={`menu-point${active === 'home' ? ' pink' : ''}`}>
                    <div onClick={startOverAction}>
                        <img src={require('../../images/home.png')} alt='Hjem menu' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReceptionMenu;